import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Box, styled, useTheme } from '@mui/material';

const StyledTooltip = styled(({ className, variant = 'default', ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, variant }) => {

  const getArrowColors = () => {
    switch (variant) {
      case 'light':
        return {
          color: theme.palette.common.white,
        };
      case 'bi-color':
      case 'default':
      default:
        return {
          color: theme.palette.grey.grey700,
        };
    }
  };

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      fontSize: 11,
      padding: 0,
    },
    [`& .${tooltipClasses.arrow}`]: {
      ...getArrowColors(),
    },
  };
});

const EATooltip = ({ title, subTitle, children, variant = 'default', width, ...props }) => {
  const theme = useTheme();

  const getTooltipColors = () => {
    switch (variant) {
      case 'light':
        return {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.grey.grey500,
        };
      case 'bi-color':
      case 'default':
      default:
        return {
          backgroundColor: theme.palette.grey.grey700,
          color: 'white',
        };
    }
  };

  return (title || subTitle) ?
    <>
      <StyledTooltip
        {...props}
        variant={variant}
        title={
          <Box sx={{ borderRadius: '4px', overflow: 'hidden', width: width ? `${width}px` : 'auto' }}>
            <Box
              sx={{
                ...getTooltipColors(),
                px: 2,
                py: 1,
              }}
            >
              {title}

              {subTitle && (
                <Box
                  sx={{
                    backgroundColor: 'white',
                    color: theme.palette.black.dark,
                    p: 1,
                    m: 1,
                    borderRadius: '4px',
                    fontStyle: 'normal',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '140%',
                  }}
                >
                  {subTitle}
                </Box>
              )}
            </Box>
          </Box>
        }
      >
        {children}
      </StyledTooltip>
    </> : children
};

export default EATooltip;
